import React, { useEffect, useRef, useState } from "react";
import label from "../../labels/administration_en.json";
import html2pdf from "html2pdf.js";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import commonLabels from "../../../common/labels/common_en.json";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getDepartmentList } from "../../../accessRightsManagement/actions/accessRightsManagementActions";
import { getExamslistByAdvertisementId } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getAdvertisementlistByYear,
  getYearList,
} from "../../../common/actions/commonActions";
import { getallActivities } from "../../actions/administrationActions";
import { SET_ALL_ACTIVITIES } from "../../../common/constants/ActionTypes";
const AllActivates = () => {
  const pdfRef = useRef(null);
  const dispatch = useDispatch();
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });

  const [printFlag, setPrintFlag] = useState(true);
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedYear, setSelectedYear] = useState("");

  const session = JSON.parse(sessionStorage.getItem("session"));

  let { examList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  let { listallActivities } = useSelector(
    (state) => state.administrationReducer,
    shallowEqual
  );

  useEffect(() => {
    dispatch({
      type: SET_ALL_ACTIVITIES,
      payload: [],
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    onCancelButton();
    dispatch(getYearList());
    setReloadItem(!reloadItem);
  }, []);

  const onCancelButton = () => {
    reset();
    dispatch({
      type: SET_ALL_ACTIVITIES,
      payload: [],
    });
    setPrintFlag(true);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };
  const onSubmit = () => {
    dispatch(getallActivities(selectedExam, setPrintFlag));
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton();
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      dispatch({
        type: SET_ALL_ACTIVITIES,
        payload: [],
      });
      setSaveButtonFlag(true);
      setPrintFlag(true);
      setReloadItem(!reloadItem);
    }
  };

  const onAdvertisementChange = (ele) => {
    setSelectedExam("");
    setConfirmClicked(false);
    setPrintFlag(true);
    setSaveButtonFlag(true);
    examList.length = 0;
    ele && dispatch(getExamslistByAdvertisementId(ele));
    dispatch({
      type: SET_ALL_ACTIVITIES,
      payload: [],
    });
    setReloadItem(!reloadItem);
  };
  const onExamChange = (ele) => {
    setSelectedExam(ele);
    setConfirmClicked(true);
    setSaveButtonFlag(false);
    setPrintFlag(true);
    dispatch({
      type: SET_ALL_ACTIVITIES,
      payload: [],
    });
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      listallActivities.examName +
      "</h5><h5>" +
      label.AllActivates +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [1, 0.4, 0.7, 0.4],
      filename: "AllActivates.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");

          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = listallActivities.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`AllActivates.pdf`);
      });
  };

  const downloadPdf = () => {
    genPdf();
    setReloadItem(!reloadItem);
  };
  return (
    <div className="dashboardContentArea">
      <h5> {label.AllActivates} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12 ">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    value={selectedYear}
                    // ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                        // <option key={index} value={element.id}>
                        //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                        // </option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo1"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo1.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.Select_Exam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam1"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam1.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <>
                        {" "}
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag}
                          onClick={handleSubmit((e) => {
                            onSubmit(e);
                            setConfirmClicked(true);
                          })}
                        >
                          {commonLabels.BUTTON_VIEW}
                        </button>
                      </>
                    )}
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary") && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        disabled={printFlag || !confirmClicked}
                        onClick={() => {
                          downloadPdf();
                        }}
                      >
                        {commonLabels.BUTTON_PRINT}
                      </button>
                    )}
                </div>
              </div>
            </div>
          </form>
        </div>
        {listallActivities && listallActivities?.activities?.length > 0 && (
          <div ref={pdfRef} className="pendingtable w-100" id="InterviewReport">
            <table className="table table-bordered text-center border border-dark">
              <thead>
                <tr>
                  <th className="text-center">{label.Srno}</th>
                  <th className="text-left">{label.AllActivates}</th>
                  <th>{label.Status}</th>
                </tr>
              </thead>
              <tbody>
                {listallActivities &&
                  listallActivities.activities.length > 0 &&
                  listallActivities.activities.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td className="text-center w-10">{index + 1}</td>
                        <td className="text-left w-60">{item.message}</td>
                        {item.flag == true &&
                          <>
                            <td className="w-20">
                              <div className="doneStatus"></div>
                            </td>
                          </>}
                        {item.flag == false &&
                          <>
                            <td className="w-20 status">
                              <div className="pendingStatus"></div>
                            </td>
                          </>}
                      </tr>
                    </>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AllActivates;
